import qs from 'qs';
import * as UUID from 'uuid';

import { LOCALES } from '../constant';
import { CONNECT_MAP } from '../../util/const';

export const tgUtils = {
  decodeTelegramUrlParameters: function decodeTelegramUrlParameters(
    encodedParameters,
    isObject = true
  ) {
    const decodedParams = encodedParameters
      .replaceAll('--', '%')
      .replaceAll('__', '=')
      .replaceAll('-', '&')
      .replaceAll('%5F', '_')
      .replaceAll('%2D', '-')
      .replaceAll('%2E', '.');
    if (isObject) return qs.parse(decodedParams);
    return decodedParams;
  },
  stringify: function stringify(obj) {
    const params = new URLSearchParams();

    function buildParams(prefix, value) {
      if (Array.isArray(value)) {
        value.forEach((v, i) => {
          if (/\[\]$/.test(prefix)) {
            params.append(prefix, v);
          } else {
            buildParams(`${prefix}[${typeof v === 'object' ? i : ''}]`, v);
          }
        });
      } else if (typeof value === 'object') {
        for (const key in value) {
          buildParams(`${prefix}[${key}]`, value[key]);
        }
      } else {
        params.append(prefix, value);
      }
    }

    for (const key in obj) {
      buildParams(key, obj[key]);
    }

    return params.toString();
  },
  encodeTelegramUrlParameters: function encodeTelegramUrlParameters(
    parameters,
    isObject = true
  ) {
    if (isObject) {
      parameters = tgUtils.stringify(parameters);
      //  parameters = qs.stringify(parameters)
    }
    return parameters
      .replaceAll('.', '%2E')
      .replaceAll('-', '%2D')
      .replaceAll('_', '%5F')
      .replaceAll('&', '-')
      .replaceAll('=', '__')
      .replaceAll('%', '--');
  },
  opendeepLink: function opendeepLink(
    paramsStr,
    {
      domain = 'tomowalletbot', //
      appname = 'app',
    }
  ) {
    var protoUrl = `tg:\/\/resolve?domain=${domain}&mode=compact&appname=${appname}&startapp=${paramsStr}`;
    if (true) {
      var iframeContEl =
        document.getElementById('tgme_frame_cont') || document.body;
      var iframeEl = document.createElement('iframe');
      iframeContEl.appendChild(iframeEl);
      var pageHidden = false;
      window.addEventListener(
        'visibilitychange',
        function() {
          pageHidden =
            document.hidden ||
            document.webkitHidden ||
            document.mozHidden ||
            document.msHidden;
        },
        false
      );
      window.addEventListener(
        'pagehide',
        function() {
          pageHidden = true;
        },
        false
      );
      window.addEventListener(
        'blur',
        function() {
          pageHidden = true;
        },
        false
      );
      if (iframeEl !== null) {
        iframeEl.src = protoUrl;
      }
      !false &&
        setTimeout(function() {
          if (!pageHidden) {
            (window as any).location = protoUrl;
          }
        }, 2000);
    } else if (protoUrl) {
      setTimeout(function() {
        (window as any).location = protoUrl;
      }, 100);
    }
  },
  getDeepLink: function({
    tMeUrl,
    params,
    mode = 'compact',
  }: {
    tMeUrl: string;
    params?: any;
    mode?: string;
    compact;
  }) {
    const [, domain, appname] = tMeUrl.match(/t\.me\/([^\/]+)\/([^\/]+)/);
    const paramsStr = params ? this.encodeTelegramUrlParameters(params) : '';

    const deepLink = `tg:\/\/resolve?domain=${domain}&mode=${mode}&appname=${appname}`;

    return paramsStr ? deepLink + `&startapp=${paramsStr}` : deepLink;
  },
};

export function getUUid() {
  return UUID.v4();
}

export function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
  );
};

export function isTelegramInAppBrowser() {
  return /Telegram/i.test(navigator.userAgent);
}

export function isPcBrowser() {
  return !isMobileDevice() && !isTelegramInAppBrowser();
}

export function getOkxLanguage(lang: string = 'en_US') {
  return LOCALES.includes(lang) ? lang : 'en_US';
}

export function getDisplayName(name: string) {
  const nameMap: Record<CONNECT_MAP, string> & { [name: string]: string } = {
    'Tomo Mini App': 'Tomo Wallet',
    'OKX Connect': 'OKX Wallet',
    'TON Connect': 'TON Wallets',
    'EVM Connect': 'EVM Wallets',
    [CONNECT_MAP.BITGET_WALLET]: 'Bitget Wallet',
    [CONNECT_MAP.UXUY_WALLET]: 'UXUY Wallet',
  };
  return nameMap[name] || name;
}

export function getDisplayDescription(name: string) {
  const nameMap: Record<CONNECT_MAP, string> & { [name: string]: string } = {
    'Tomo Mini App': 'Multichain',
    'OKX Connect': 'TG & App',
    'TON Connect': '',
    'EVM Connect': '',
    [CONNECT_MAP.BITGET_WALLET]: 'mini app',
    [CONNECT_MAP.UXUY_WALLET]: 'mini app',
  };
  return nameMap[name] || '';
}

export default {};
